import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const isDownloadingCardsList = createSelector(creditCardsState, (creditCards) => creditCards.download.isDownloading);
